module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.358.9/frontend/_next/static/images/right-bottom-0f2ffc021188adfc221f20a2c248df7e.png";